import { c as _c } from "react/compiler-runtime";
import { std } from '@funkey/shared/utils';
import { cx } from 'class-variance-authority';
import { useStateObject } from '~/utils/react';
import { TRANSLATION_MAP } from './shared';
export default function LanguageSelectByState(props) {
  const $ = _c(4);
  let t0;
  if ($[0] !== props.state) {
    t0 = std.Object.keys(TRANSLATION_MAP).map(lang => {
      const config = TRANSLATION_MAP[lang];
      const Icon = config.icon;
      return <li className="contents" key={lang}><button type="button" onClick={() => props.state.set(lang)} className={cx("flex items-center gap-3 rounded-5xl border px-7 py-5 transition hover:border-blue-900", props.state.value === lang ? "border-blue-200 text-turqoise-600" : "border-transparent text-primary")}><Icon />{config.label}</button></li>;
    });
    $[0] = props.state;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <ul className="flex">{t0}</ul>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
LanguageSelectByState.useState = (initialLanguage?: keyof typeof TRANSLATION_MAP) => useStateObject(initialLanguage ?? 'nl');